module.exports = __webpack_public_path__ + "static/media/D-DIN.847a563b.eot";